import { TESTIDS } from "@/constants/testIds";
import { MapPin, Navigation } from "lucide-react";

export default function GeoWidget({ userPos, office, distance, inRange, loading }) {
  return (
    <div data-testid={TESTIDS.mapWidget} className="border border-black/10 bg-white h-full flex flex-col">
      <div className="px-4 py-3 border-b border-black/10 flex items-center justify-between">
        <div className="label-tiny">Geo-Fencing</div>
        <div className="text-xs text-gray-500">Radius kantor</div>
      </div>

      <div className="relative flex-1 min-h-[240px] bg-[repeating-linear-gradient(45deg,#f5f5f5_0_10px,#ffffff_10px_20px)] overflow-hidden">
        {/* Office point */}
        <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
          <div className={`w-40 h-40 border-2 ${inRange ? "border-signal-ok" : "border-signal-late"} rounded-full opacity-60`} />
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="w-3 h-3 bg-klein rounded-full" title="Kantor" />
          </div>
        </div>
        {/* User pos */}
        {userPos && (
          <div
            className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
            style={{
              transform: `translate(calc(-50% + ${Math.min(Math.max((userPos.dx || 0) * 0.5, -80), 80)}px), calc(-50% + ${Math.min(Math.max((userPos.dy || 0) * 0.5, -80), 80)}px))`,
            }}
          >
            <div className={`w-4 h-4 ${inRange ? "bg-signal-ok" : "bg-signal-late"} rounded-full ring-4 ring-white`} />
          </div>
        )}
      </div>

      <div className="grid grid-cols-3 border-t border-black/10">
        <div className="p-3 border-r border-black/10">
          <div className="label-tiny">Jarak</div>
          <div data-testid={TESTIDS.distanceIndicator} className={`font-display font-bold text-xl mt-1 ${inRange ? "text-signal-ok" : "text-signal-late"}`}>
            {loading ? "—" : distance != null ? `${Math.round(distance)} m` : "N/A"}
          </div>
        </div>
        <div className="p-3 border-r border-black/10">
          <div className="label-tiny">Radius</div>
          <div className="font-display font-bold text-xl mt-1 flex items-center gap-1">
            <MapPin className="w-4 h-4" /> {office?.radius_meters ?? 0} m
          </div>
        </div>
        <div className="p-3">
          <div className="label-tiny">Status</div>
          <div className={`font-display font-bold text-xl mt-1 ${inRange ? "text-signal-ok" : "text-signal-late"}`}>
            {loading ? "—" : inRange ? "Dalam Area" : "Di Luar"}
          </div>
        </div>
      </div>

      {userPos?.lat && (
        <div className="px-4 py-2 border-t border-black/10 text-xs font-mono text-gray-600 flex items-center gap-2">
          <Navigation className="w-3 h-3" />
          {userPos.lat.toFixed(5)}, {userPos.lng.toFixed(5)}
        </div>
      )}
    </div>
  );
}
